import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

// Frame for public pages outside the landing page (invites, cohorts, the focus timer).
export default function PublicLayout({ children, className = "" }) {
  return (
    <div className="landing relative min-h-screen bg-[#0A0A0A] text-[#F5F5F0] overflow-x-clip">
      <Nav />
      <main className={`relative pt-28 pb-24 sm:pt-32 ${className}`}>{children}</main>
      <Footer />
    </div>
  );
}
